'use client';

// import useSize from '@/src/hooks/useSize'
// import { IProps } from '@/types'
import { c as _c } from "react/compiler-runtime";
import gsap from 'gsap';
import React, { useRef, useState } from 'react';

// import CardItem from '../item/CardItem'
import ScrollTrigger from 'gsap/ScrollTrigger';
import { Swiper, SwiperSlide } from 'swiper/react';
import { FreeMode, Scrollbar, Mousewheel } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/free-mode';
import 'swiper/css/scrollbar';
import { cx } from '@/src/styles/stylebook';
import useScreenSize from '@/src/hooks/useScreenSize';
gsap.registerPlugin(ScrollTrigger);
const FreeCarousel = t0 => {
  const $ = _c(18);
  let children;
  let className;
  let rest;
  let slideWrapperClassName;
  if ($[0] !== t0) {
    ({
      children,
      className,
      slideWrapperClassName,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = rest;
    $[4] = slideWrapperClassName;
  } else {
    children = $[1];
    className = $[2];
    rest = $[3];
    slideWrapperClassName = $[4];
  }
  const {
    width
  } = useScreenSize();
  useState(0);
  const swiperRef = useRef(null);
  let t1;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [FreeMode, Scrollbar, Mousewheel];
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const t2 = width < 768 ? 10 : 16;
  let t3;
  if ($[6] !== className) {
    t3 = cx("flex w-full flex-nowrap", className);
    $[6] = className;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== children || $[9] !== slideWrapperClassName) {
    let t5;
    if ($[11] !== slideWrapperClassName) {
      t5 = (child, index) => <SwiperSlide key={index} style={{
        width: "auto"
      }} className={slideWrapperClassName}>{child}</SwiperSlide>;
      $[11] = slideWrapperClassName;
      $[12] = t5;
    } else {
      t5 = $[12];
    }
    t4 = React.Children.map(children, t5);
    $[8] = children;
    $[9] = slideWrapperClassName;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[13] !== rest || $[14] !== t2 || $[15] !== t3 || $[16] !== t4) {
    t5 = <Swiper ref={swiperRef} modules={t1} mousewheel={true} scrollbar={false} freeMode={true} slidesPerView="auto" direction="horizontal" spaceBetween={t2} className={t3} {...rest}>{t4}</Swiper>;
    $[13] = rest;
    $[14] = t2;
    $[15] = t3;
    $[16] = t4;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  return t5;
};

// const SwiperContainer = styled(Swiper)<any>`
//   display: flex;
//   align-items: flex-end;
//   flex-wrap: nowrap;
//   min-width: 100vw;
//   min-height: 100vh;
//   padding-bottom: ${({ theme }) => `calc(${theme.spacing.vmarg} * 8)`};
//   /* transform: rotate(90deg); */
//   /* max-width: unset !important; */
//   /* width: max-content; */
//   /* position: absolute; */
//   /* top: 0; */
//   /* left: 0; */
//   z-index: 10;

//   .swiper-wrapper {
//     align-items: flex-end;
//     transition-duration: 0.8s !important;
//     transition-timing-function: cubic-bezier(0.14, 0.37, 0.29, 0.98) !important;
//   }
//   .swiper-slide {
//     width: auto;
//     &:first-child {
//       margin-left: ${({ theme }) => `calc(${theme.spacing.marg} / 2)`};
//     }
//     &:last-child {
//       padding-right: ${({ theme }) => `calc(${theme.spacing.marg} / 2)`};
//     }
//   }
// `

// const Container = styled.div`
//   >*{
//     display: inline-block;
//     /* transform: rotate(90deg); */
//     /* transform-origin: center bottom; */
//   }
// `
export default FreeCarousel;